import { BigNotificationIcon } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';

import styles from './NoNotification.module.scss';

interface Props {
  smallSize?: boolean;
}

const NoNotification: FunctionComponent<Props> = ({ smallSize }) => {
  return (
    <div
      className={
        smallSize ? styles.NoNotificationSmallSize : styles.NoNotification
      }
      data-testid="nonotification-holder"
    >
      <BigNotificationIcon
        style={{
          width: smallSize ? 150 : 'auto',
          height: smallSize ? 120 : 'auto',
        }}
      />
      <div className={styles.text}>
        {_t('notifications:you_have_no')} <br />
        {_t('notifications:notificationss')}
      </div>
    </div>
  );
};

export default NoNotification;
